<script setup>
import InlineSvg from 'vue-inline-svg'
const props = defineProps({
  src: String,
  hardCode: Boolean,
  preload: Boolean
})
const modules = import.meta.glob([
  '@/public/images/*.svg',
  '@/public/images/*/*-badge*.svg',
  '@/public/images/homepage/*.svg',
  '@/public/images/tech/shared/*.svg',
  '@/public/images/tech/*/badge.svg'
])

const svgComponent = modules[`/public${props.src}`]
const useHardCode = svgComponent && props.hardCode
const component = useHardCode ? await svgComponent() : InlineSvg

if (props.preload && props.src && !useHardCode) {
  useHead({
    link: [
      {
        key: `preload-inline-svg-${props.src}`,
        rel: 'preload',
        as: 'fetch',
        type: 'image/svg+xml',
        href: props.src,
        crossorigin: 'anonymous'
      }
    ]
  })
}
</script>

<template>
  <component
    :is="component"
    :src="useHardCode ? null : src" />
</template>
